module.exports = __webpack_public_path__ + "static/media/rads.2dbe29ac.svg";